/**
 * Copy for the ATS (American Tradeshow Services) toolkit fields, shared by the
 * per-conference form and the reusable-config create/edit forms. ATS badges
 * carry the attendee record encrypted; the layout and password both come from
 * the show's ATS barcode layout sheet.
 */
export const ATS_LAYOUT_PLACEHOLDER =
  'BadgeID^FirstName^LastName^Company^Email';

export const ATS_LAYOUT_EXTRA =
  'Paste the "Start ASCII" line of Sample 1 from the ATS barcode layout sheet: ' +
  'the field names in order, separated by ^. It must include a first-name and a last-name field.' +
  ' For an ATS show whose badges carry only the badge ID ("ID-only"), use ats_api instead.';

export const ATS_PASSWORD_EXTRA = 'The decryption password from the same ATS layout sheet.';

/** Same rule as the server: reject (never trim) a password with surrounding spaces, since the AES key is its raw bytes. */
export const ATS_PASSWORD_WHITESPACE_RULE = {
  validator: (_: unknown, v?: string) =>
    !v || v === v.trim() ? Promise.resolve() : Promise.reject(new Error('Password has leading or trailing spaces')),
};
